<template>
  <th>
    <div class="th-box">
      <span class="th-text ellipsis" data-original-title="">
        <slot></slot>
        {{displayName}}
      </span>
    </div>
  </th>
</template>

<script>
export default {
  props:['prop', 'displayName', 'name', 'width']
}
</script>

<style>

</style>